import logo from './images/logic-icon.png';
import './App.css';
import { Container, Typography } from '@mui/material';
import ImgUpload from './pages/Upload';
import Retrival from './pages/Retrival';
import { Route, Routes } from 'react-router-dom';


function App() {
  return (
    <div className="App">
      <header className="">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <Container maxWidth="md" sx={{ marginTop: 4 }}>
      <Routes>
         <Route path='/' element={<ImgUpload/>} />
         <Route path='/retrive' element={<Retrival/>} />
       </Routes>
    </Container>
    </div>
  );
}

export default App;
